export const iconFontAwesomeMapsFlagCheckered = (
	<i className="fa-solid fa-flag-checkered"></i>
);
